import { render } from "./CreateUserID.vue?vue&type=template&id=93f416e8&scoped=true"
import script from "./CreateUserID.vue?vue&type=script&lang=js"
export * from "./CreateUserID.vue?vue&type=script&lang=js"

import "./CreateUserID.vue?vue&type=style&index=0&id=93f416e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f416e8"]])

export default __exports__